import styled from '@emotion/styled'
import { WizardContent } from 'components/wizard/wizardContent/WizardContent'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const ProfileWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  max-width: 90vw;
  // IMPROVE it should be max-width: calc(100vw - var(--space)); but it doesn't work
`

export const ProfileContent = styled(WizardContent)`
  margin-bottom: ${pxToRem(120)}rem;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: ${pxToRem(120)}rem !important;
  }

  max-width: 90vw;
  // IMPROVE it should be max-width: calc(100vw - var(--space)); but it doesn't work
`
